const set = (prop) => (state, payload) => {
  state[prop] = payload;
};

export default {
  setCategories: set('categories'),
  setBonuses: set('bonuses'),
  setCategoryId: set('category_id'),
  setSubcategoryId: set('subcategory_id'),
  setOrderPrice: set('orderPrice'),
  setCurrency: set('currency'),
  setLang: set('lang'),
  updateOrder: set('tastes'),
  setSum: set('sum'),
  setComment: set('comment'),
  setError: set('error'),
  orderIncrement: set('id'),
  setDirty: set('dirty'),
  updateBonus: set('extras'),
  saveOrder: set('response'),
  setCurrencyConverter: set('europln'),

  addFile(state, payload) {
    state.files.push(payload);
  },
  setSubcategories(state, payload) {
    const { subcategories } = state.categories.find((category) => category.id === payload);
    state.subcategories = subcategories;
  },
  clearAllFiles(state) {
    state.files = [];
  },
  clearOrder(state) {
    state.category_id = null;
    state.subcategory_id = null;
    state.tastes = [];
    state.orderPrice = null;
    state.sum = 0;
    state.error = '';
    state.dirty = null;
    state.currency = 'zł';
    state.lang = 'pl';
    state.comment = '';
    state.files = [];
    state.response = null;
    state.extras = {
      bonus: false,
    };
  },
};
